import { render, staticRenderFns } from "./fastcheckout.vue?vue&type=template&id=10cfede6"
import script from "./fastcheckout.vue?vue&type=script&lang=js"
export * from "./fastcheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports